import { ContextMenuItem } from "lib/@components/context-menu-bar/context-menu-item"
import { OpenSchedule } from "event-definitions"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function EditScheduleMenuItem() {
    const { schedule } = useBoundContext()
    return <ContextMenuItem icon="clarity:edit-solid" label="Tailor Schedule" onClick={go} />

    function go() {
        // Pass the regime-pinned version (FIQ-676): without it the tailoring editor loads the
        // latest published schedule as its baseline, so "undo tailoring" would apply newly
        // published values without the "update tailored schedule" action.
        OpenSchedule(schedule.id).raise(schedule, { editEx: true }, { version: schedule.version })
    }
}
